export function setToken(token: string) {
  localStorage.setItem('token', token);
}

export function getToken(): string | null {
  return localStorage.getItem('token');
}

export function removeToken() {
  localStorage.removeItem('token');
}

export function isAuthenticated(): boolean {
  return !!getToken();
}

export function parseJwt(token: string): any {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}

export function getCurrentUser() {
  const token = getToken();
  if (!token) return null;
  return parseJwt(token);
}

export function isClient(): boolean {
  const user = getCurrentUser();
  return user?.role === 'CLIENT';
}

export function isAdmin(): boolean {
  const user = getCurrentUser();
  return user?.role === 'ADMIN';
}

export function isManager(): boolean {
  const user = getCurrentUser();
  return user?.role === 'MANAGER';
}

export function isSales(): boolean {
  const user = getCurrentUser();
  return user?.role === 'SALES';
}